import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import VueFloatLabel from 'vue-float-label'
import Toasted from 'vue-toasted'
// import {faWindowClose as faWindowCloseRegular} from '@fortawesome/free-regular-svg-icons'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faClipboardCheck, faWindowClose, faCheckSquare, faTasks, faSync, faClipboard, faDownload, faSpinner,faExclamationTriangle,faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

require('./assets/css/normalize.css')
// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch()

library.add(faClipboardCheck, faWindowClose, faCheckSquare, faTasks, faSync, faClipboard,faDownload, faSpinner, faExclamationTriangle, faCheckCircle,faExclamationCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue.use(VueFloatLabel)
Vue.use(Toasted, {
  iconPack: 'fontawesome'
})

Vue.toasted.register("error_login",
  (message) => {
    return message || 'Log in failed, Please contact our support team'
  }, {
    type: "error",
    theme: "toasted-primary",
    position: "bottom-center",
    duration: null,
    singleton: true,
    action: {
      icon: "fa-window-close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  })
Vue.toasted.register("error_message",
  (payload) => {
    // if there is no message passed show default message
    if(!payload.message) {
      return 'Oops! Something went wrong..'
    }
    // if there is a message show it with the message
    return payload.message;    
  }, {
    type: "error",
    theme: "toasted-primary",
    position: "bottom-center",
    duration: 7000,
    singleton: true,
    action: {
      icon: "window-close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  })

Vue.toasted.register("success_message",   (payload) => {
  // if there is no message passed show default message
  if(!payload.message) {
    return `<p>Deployment Complete!</p>`
  }
  // if there is a message show it with the message
  return payload.message;    
}, {
  type: "success",
  theme: "toasted-primary",
  position: "bottom-center",
  duration: 5000,
  singleton: true,
  className: "successMessage",
  icon: "check-square",
  action: {
    icon: "window-close",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
})

Vue.prototype.$http = function (url, method, token, body, header) {
  
  const config = {
    method: `${method}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    },
    body: JSON.stringify(body)
  }

  if (header) {
    config.headers.jobId = header
  }

  function status(response) {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else if (response.status === 401 || response.status >= 404) {
      return Promise.reject(response)
    } else {
      return response.json().then(json => {
        return Promise.reject(json)
      })
    }
  }

  function json(response) {
    return response.json()
  }

  return fetch(url, config)
    .then(status)
    .then(json)
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
